var _circle, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatusFail(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 16,
    cy: 16,
    r: 9,
    fill: "#E75B55"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16 17.06l2.97 2.97 1.06-1.06L17.06 16l2.97-2.97-1.06-1.06L16 14.94l-2.97-2.97-1.06 1.06L14.94 16l-2.97 2.97 1.06 1.06L16 17.06z",
    fill: "#E75B55"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMzIiIGhlaWdodD0iMzIiIHZpZXdCb3g9IjAgMCAzMiAzMiIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBvcGFjaXR5PSIwLjEiIGN4PSIxNiIgY3k9IjE2IiByPSI5IiBmaWxsPSIjRTc1QjU1Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMTYuMDAwMSAxNy4wNjA3TDE4Ljk2OTcgMjAuMDMwM0wyMC4wMzA0IDE4Ljk2OTdMMTcuMDYwNyAxNkwyMC4wMzA0IDEzLjAzMDNMMTguOTY5NyAxMS45Njk3TDE2LjAwMDEgMTQuOTM5M0wxMy4wMzA0IDExLjk2OTdMMTEuOTY5NyAxMy4wMzAzTDE0LjkzOTQgMTZMMTEuOTY5NyAxOC45Njk3TDEzLjAzMDQgMjAuMDMwM0wxNi4wMDAxIDE3LjA2MDdaIiBmaWxsPSIjRTc1QjU1Ii8+Cjwvc3ZnPgo=";
export { SvgStatusFail as ReactComponent };